// deskApi.ts
import apiClient from '../api/apiClient';
import {ResponseDto} from "./ResponseDto";
import {PageTypes} from "../types/page.types";

// ==================== Q&A ====================
export interface CreateQnADto {
    category: string;
    questionTitle: string;
    questionContent: string;
}

export const createQnA = (data: FormData) =>
    apiClient.post<ResponseDto<{ id: number }>>('/api/front/desk/qna/create', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

export interface QnADetailDto {
    seq: number;
    qnaCode: string;
    memberCode?: string;
    memberId?: string;
    memberName?: string;
    memberType?: string;
    category?: string;
    questionTitle: string;
    questionContent: string;
    status: string;
    answerTitle?: string;
    answerContent?: string;
    answeredDate?: string;
    answerAdmin?: string;
    regDate: string;
    updUser?: string;
    updDate?: string;
    regUser?: string;
    questionFileList?: Array<{
        seq: number;
        fileName: string;
        fileUrl: string;
        fileSize?: number;
    }>;
}

export const getQnADetail = (qnaCode: string) =>
    apiClient.get<ResponseDto<QnADetailDto>>(`/api/front/desk/qna/${qnaCode}`);

export const deleteQnA = (qnaCode: string) =>
    apiClient.delete<ResponseDto<void>>(`/api/front/desk/qna/${qnaCode}`);

export interface QnAListItemDto {
    seq: number;
    qnaCode: string;
    questionTitle: string;
    status: string;
    regDate: string;
    answerContent?: string;
    answeredDate?: string;
}

export const getQnAList = () =>
    apiClient.get<ResponseDto<QnAListItemDto[]>>('/api/front/desk/qna/list');

export interface UpdateQnADto {
    category: string;
    questionTitle: string;
    questionContent: string;
}

export const updateQnA = (qnaCode: string, data: FormData) =>
    apiClient.put<ResponseDto<void>>(`/api/front/desk/qna/${qnaCode}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

// ==================== 제휴문의 ====================
export interface CreateInquiryDto {
    category: string;
    title: string;
    content: string;
}

export const createInquiry = (data: FormData) =>
    apiClient.post<ResponseDto<{ id: number }>>('/api/front/desk/inquiry/create', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

// ==================== FAQ ====================
export interface FAQListItemDto {
    seq: number;
    faqCode: string;
    category: string;
    title: string;
    answer: string;
    displayYn: string;
    regDate: string;
    updDate: string;
    regUser: string;
}

export interface FAQDetailDto {
    seq: number;
    faqCode: string;
    category: string;
    title: string;
    answer: string;
    displayYn: string;
    regDate: string;
    updDate: string;
    regUser: string;
    fileList?: Array<{
        seq: number;
        fileName: string;
        filePath: string;
        fileSize: number;
    }>;
}

export interface FAQSearchParams {
    page?: number;
    size?: number;
    keyword?: string;
    category?: string;
}

export const getFaqList = (params: FAQSearchParams) =>
    apiClient.get<ResponseDto<PageTypes & { rows: FAQListItemDto[] }>>('/api/front/desk/faq/list', { params });

export const getFaqDetail = (seq: number) =>
    apiClient.get<ResponseDto<FAQDetailDto>>(`/api/front/desk/faq/${seq}`);

// ==================== Notice ====================
export interface NoticeListItemDto {
    seq: number;
    noticeCode: string;
    title: string;
    content?: string;
    status: string;
    displayYn: boolean;
    isPinned: string;
    viewCount: number;
    target?: string;
    regUser?: string;
    regDate: string;
    updUser?: string;
    updDate?: string;
}

export interface NoticeDetailDto {
    seq: number;
    noticeCode: string;
    title: string;
    content: string;
    status: string;
    displayYn: boolean;
    isPinned: string;
    viewCount: number;
    target?: string;
    regUser?: string;
    regDate: string;
    updUser?: string;
    updDate?: string;
    fileList?: Array<{
        seq: number;
        fileName: string;
        filePath: string;
        fileSize: number;
    }>;
}

export interface NoticeSearchParams {
    page?: number;
    size?: number;
}

export const getNoticeList = (params?: NoticeSearchParams) =>
    apiClient.get<ResponseDto<PageTypes & { rows: NoticeListItemDto[] }>>('/api/front/desk/notice/list', { params });

export const  getNoticeDetail = (noticeCode: string) =>
    apiClient.get<ResponseDto<NoticeDetailDto>>(`/api/front/desk/notice/${noticeCode}`);